import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { useTheme } from '../contexts/ThemeContext';

export default function StatusPieChart({ data, labels, colors }) {
  const { theme } = useTheme();

  const safeData = Array.isArray(data) ? data : [];
  const series = safeData.map(v => Number(v) || 0);
  const totalSum = series.reduce((a, b) => a + b, 0);

  if (safeData.length === 0 || totalSum === 0) {
    return (
      <div className="flex items-center justify-center h-48 text-xs text-gray-400">
        No status data recorded
      </div>
    );
  }

  const options = {
    chart: {
      type: 'pie',
      width: '100%',
      animations: {
        enabled: false,
      },
      redrawOnParentResize: false,
    },
    labels: Array.isArray(labels) ? labels : [],
    colors: colors || (theme === 'light' 
      ? ["#D3EE98", "#73EC8B", "#54C392", "#15B392"] 
      : ["#5A7A3B", "#256A3F", "#25605B", "#1D4D42"]),
    stroke: {
      show: true,
      width: 2,
      colors: [theme === 'light' ? '#fff' : '#1f2937']
    },
    legend: {
      position: 'bottom',
      labels: {
        colors: theme === 'light' ? '#374151' : '#d1d5db'
      }
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: '100%'
        },
        legend: {
          position: 'bottom'
        }
      }
    }]
  };

  return (
    <div className="w-full">
      <ReactApexChart options={options} series={series} type="pie" width="100%" />
    </div>
  );
}
